import {
  chakra,
  Modal,
  ModalContent,
  ModalCloseButton,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useDisclosure,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

import type { Transaction } from 'types/api/transaction';

import AdditionalInfoButton from 'ui/shared/AdditionalInfoButton';
import Popover from 'ui/shared/chakra/Popover';

import TxAdditionalInfoContainer from './TxAdditionalInfoContainer';
import TxAdditionalInfoContent from './TxAdditionalInfoContent';

type Props =
  ({
    hash: string;
    tx?: undefined;
  } |
  {
    hash?: undefined;
    tx: Transaction;
  }) & {
    isMobile?: boolean;
    isLoading?: boolean;
    className?: string;
    buttonIconSrc?: string;
    buttonIconSize?: string;
  };

const TxAdditionalInfo = ({ hash, tx, isMobile, isLoading, className, buttonIconSrc, buttonIconSize }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const popoverBg = useColorModeValue('rgba(255, 255, 255, 0.9)', 'rgba(30, 30, 30, 0.7)');
  const popoverBorder = useColorModeValue('1px solid rgba(0, 0, 0, 0.1)', '1px solid rgba(255, 255, 255, 0.1)');
  const popoverColor = useColorModeValue('#000000', 'inherit');

  const content = hash !== undefined ? <TxAdditionalInfoContainer hash={ hash }/> : <TxAdditionalInfoContent tx={ tx }/>;

  if (isMobile) {
    return (
      <>
        <AdditionalInfoButton
          onClick={ onOpen }
          isLoading={ isLoading }
          className={ className }
          iconSrc={ buttonIconSrc }
          iconSize={ buttonIconSize }
        />
        <Modal isOpen={ isOpen } onClose={ onClose } size="full">
          <ModalContent paddingTop={ 4 }>
            <ModalCloseButton/>
            { content }
          </ModalContent>
        </Modal>
      </>
    );
  }
  return (
    <Popover placement="right-start" openDelay={ 300 } isLazy>
      { ({ isOpen }) => (
        <>
          <PopoverTrigger>
            <AdditionalInfoButton
              isOpen={ isOpen }
              isLoading={ isLoading }
              className={ className }
              iconSrc={ buttonIconSrc }
              iconSize={ buttonIconSize }
            />
          </PopoverTrigger>
          <PopoverContent
            sx={{
              width: '326px',
              background: popoverBg,
              backdropFilter: 'blur(10px)',
              border: popoverBorder,
              color: popoverColor,
            }}
          >
            <PopoverBody fontWeight={ 400 } fontSize="sm" >
              { content }
            </PopoverBody>
          </PopoverContent>
        </>
      ) }
    </Popover>
  );
};

export default React.memo(chakra(TxAdditionalInfo));
